/**
 * Featured Lookbook — homepage slider behavior.
 *
 * Layered on top of <looks-filter>:
 *   - looks-filter handles tab filtering against the server-rendered cards.
 *   - featured-lookbook adds: Fisher-Yates shuffle (random mode), prev/next
 *     arrow controls bound to the scroll-snap track, and a hard cap from
 *     data-max-items.
 *
 * Markup contract: see sections/featured-lookbook.liquid.
 */

(function () {
  'use strict';

  function fisherYatesShuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function setupSection(root) {
    const track = root.querySelector('[data-featured-track]');
    if (!track) return;

    const source = root.dataset.source || 'manual';
    const shuffle = root.dataset.shuffle === '1';
    const maxItems = parseInt(root.dataset.maxItems || '0', 10);

    // 1. Optional shuffle — done in DOM order before looks-filter takes over.
    if (shuffle) {
      const cards = Array.from(track.querySelectorAll('[data-look-card]'));
      fisherYatesShuffle(cards);
      cards.forEach((card) => track.appendChild(card));
    }

    // 2. Hard cap. We hide everything past the cap; looks-filter respects the
    //    [hidden] attribute when computing matching/visible counts. For "random"
    //    we cap before tabs apply; for "category" we cap inside the filter
    //    listener so each tab gets up to N visible.
    function applyCap(scope) {
      if (!maxItems || maxItems <= 0) return;
      const all = Array.from(track.querySelectorAll('[data-look-card]'));
      const considered = scope === 'all'
        ? all
        : all.filter((c) => !c._cappedHidden && !c.hidden);
      considered.forEach((card, idx) => {
        if (idx >= maxItems) {
          card.hidden = true;
          card._cappedHidden = true;
        } else {
          card._cappedHidden = false;
        }
      });
    }

    if (source === 'random' || source === 'manual' || source === 'by_priority') {
      applyCap('all');
    }

    if (source === 'category') {
      // Re-cap whenever looks-filter swaps the active set.
      root.addEventListener('looks:loaded', () => applyCap('visible'));
      // Initial cap after first paint.
      requestAnimationFrame(() => applyCap('visible'));

      // Tab click → reset the slider's horizontal scroll so the new set
      // starts from the beginning rather than at whatever offset the
      // previous tab left it at. Instant (no smooth) — the swap itself is
      // instant; a smooth scroll on top would feel laggy.
      root.addEventListener('looks:swapped', () => {
        track.scrollLeft = 0;
        // Arrow/progress re-eval on filter is handled by the unified <product-content-slider>
        // (its data-observe-track MutationObserver) — no manual call needed here.
      });
    }

    // Arrows + scroll-progress indicator are now handled by the unified
    // <product-content-slider> wrapper (binds [data-slider-prev]/[data-slider-next],
    // builds the progress bar, and re-evaluates on filter via data-observe-track).
    // This section keeps only shuffle + cap + filter wiring above.
  }

  function init() {
    document.querySelectorAll('looks-filter.featured-lookbook').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
